<template>
	<v-dialog v-model="dialog" fullscreen hide-overlay  transition="dialog-bottom-transition">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="primary" dark v-bind="attrs" v-on="on" elevation="0" :small="$vuetify.breakpoint.mdAndDown">
				Acessar lista de Reservas
			</v-btn>
		</template>
		<v-toolbar dark color="primary" flat>
			<v-btn icon dark @click="dialog = false"> <v-icon>mdi-close</v-icon> </v-btn>
			<v-toolbar-title>Reservas</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-btn dark text @click="dialog = false"> Fechar </v-btn>
			</v-toolbar-items>
		</v-toolbar>
		<v-card outlined class="mx-1">
			<v-card-text>
				<v-row>
					<v-col cols="12" md="3" sm="12" >
						<v-date-picker color="secondary"
							full-width no-title
							locale="pt-br"
							v-model="filterDatePicker"
							:events="$store.agendamentosTodosStore.getters.getEventos.map(obj => obj.data)"
						></v-date-picker>
					</v-col>
					<v-col cols="12" md="9" sm="12" >
						<v-sheet v-if="$vuetify.breakpoint.xsOnly">
							<v-toolbar flat >
								<div>
									<v-btn small outlined class="mr-1" color="grey darken-2" @click="setToday">
										Hoje
									</v-btn>
									<v-btn v-if="type != 'category'" small outlined class="mr-1" color="grey darken-2" @click="type='category'">
										Agrupado
									</v-btn>
									<v-btn v-if="type != 'day'" small outlined class="mr-1" color="grey darken-2" @click="type='day'">
										Diário
									</v-btn>
									<v-btn v-if="type != 'month'" small outlined class="mr-1" color="grey darken-2" @click="type='month'">
										Mensal
									</v-btn>
								</div>
								<v-spacer></v-spacer>
							</v-toolbar>
						</v-sheet>
						<v-sheet>
							<v-toolbar flat >
								<v-btn fab text small color="grey darken-2" @click="prev" >
									<v-icon small> mdi-chevron-left </v-icon>
								</v-btn>
								<v-btn fab text small color="grey darken-2" @click="next">
									<v-icon small> mdi-chevron-right </v-icon>
								</v-btn> 
								<v-toolbar-title v-if="$refs.calendar"> {{ $refs.calendar.title }} </v-toolbar-title>
								<v-spacer></v-spacer>
								<div v-if="$vuetify.breakpoint.smAndUp">
									<v-btn small outlined class="mr-1" color="grey darken-2" @click="setToday">
										Hoje
									</v-btn>
									<v-btn v-if="type != 'category'" small outlined class="mr-1" color="grey darken-2" @click="type='category'">
										Agrupado
									</v-btn>
									<v-btn v-if="type != 'day'" small outlined class="mr-1" color="grey darken-2" @click="type='day'">
										Diário
									</v-btn>
									<v-btn v-if="type != 'month'" small outlined class="mr-1" color="grey darken-2" @click="type='month'">
										Mensal
									</v-btn>
								</div>
							</v-toolbar>
						</v-sheet>
						<v-sheet height="500"> 
							<v-progress-linear v-if="computedIsLoading" indeterminate size="30" />
							<v-calendar ref="calendar" 
								v-model="focus"
								color="primary"
								:type="type"
								locale="pt-br"
								:first-interval="6"
								:interval-count="16/*16 horas a partir das 7h*/"
								:interval-height="27/*altura entre o intervalo de horas*/"
								category-show-all
								event-more
								event-more-text="+ reservas"
								@click:event="showEvent"
								@click:more="viewDay"
								:categories="$store.agendamentosTodosStore.getters.getSalasCategory"
								:events="$store.agendamentosTodosStore.getters.getEventos"
								:event-color="getEventColor"
								@change="onChange"
								
								>
								<!-- label do dia na view month -->
								<template v-slot:day-label="{ date, day, present }">
									<v-btn icon :class="present ? 'primary' : ''" 
										:color="present ? 'white' : 'secondary'" @click="viewDay">{{day}}</v-btn>
								</template>

								<!-- Customizar nome das categorias -->
								<template v-slot:category="{ category }">
									<strong class="px-1">{{category}}</strong>
								</template>
								<template v-slot:day-label-header="{ day, present }">
									<v-btn icon :class="present ? 'primary' : 'secondary'" color="white" @click="type='day'"
										:loading="$store.agendamentosTodosStore.getters.getIsLoading">
										{{day}}
									</v-btn>
								</template>
								<template v-slot:event="{event}">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn text color="white" dark v-bind="attrs" v-on="on" small>
												<span v-if="event.status_agenda== 'APROVADO'">{{event.category}} - {{event.solicitante.split(" ")[0]}} - {{event.curso|truncate(15)}}
												</span>
												<span v-else-if="event.status_agenda== 'PENDENTE'">
													Aguardando aprovação
												</span>
												<span v-else>Reserva Negada</span>
											</v-btn>
										</template>
										<div>
											<div>{{event.solicitante}}</div>
											<v-divider></v-divider>
											<div>{{event.category}} - {{event.data}}</div>
											<div>{{event.titulo_aula}}</div>
											<div>{{event.status_agenda}}</div>
										</div>
									</v-tooltip>
								</template>
							</v-calendar>
							<v-menu v-model="selectedOpen" width="350" :close-on-content-click="false" :activator="selectedElement" offset-x>
								<v-card color="grey lighten-4" width="350" flat>
									<v-card-title class="grey lighten-2 pa-1">
										<v-btn small icon class="mr-4" @click="selectedOpen=false">
											<v-icon small>mdi-arrow-left</v-icon>
										</v-btn>
										<span class="subtitle-2">
											# {{selectedEvent.id}} - {{selectedEvent.category}}
										</span>
										<v-spacer></v-spacer>
									</v-card-title>
									<v-card-text class="pa-4">
										<div>
											<div> <b>Turma:</b> {{selectedEvent.codturma}}</div>
											<div> <b>Solicitante:</b> {{selectedEvent.solicitante}}</div>
											<div> <b>Laboratório:</b> {{selectedEvent.category}}</div>
											<div> <b>Finalidade:</b> {{selectedEvent.finalidade}}</div>
											<div> <b>Data:</b> {{selectedEvent.formatted_data}}</div>
											<div> <b>Título da prática:</b> {{selectedEvent.titulo_aula}}</div>
											<div> <b>Curso:</b> {{selectedEvent.curso}}</div>
											<div> <b>Disciplina:</b> {{selectedEvent.disciplina}}</div>
											<!-- 
											<div> <b>Curso:</b> {{selectedEvent.curso}}</div>
											<div> <b>Disciplina:</b> {{selectedEvent.disciplina}}</div>
											<div> <b>Status: <span :class="getColor(selectedEvent.status_agenda)">{{selectedEvent.status_agenda}}</span></b></div> -->
											
											<v-divider class="my-2"></v-divider>
											
											<div v-if="selectedEvent.file_protocolo_pratica || selectedEvent.file_reagentes_equipamentos">
												<h4>Arquivos</h4>
												<v-btn v-if="selectedEvent.file_protocolo_pratica"
													@click.stop="downloadFile(get_base_url_backend+selectedEvent.file_protocolo_pratica)"
													color="blue" class="mr-1 mt-1 white--text"
													:small="$vuetify.breakpoint.xsOnly">
													Procedimento Prático <v-icon right dark> mdi-cloud-download </v-icon>
												</v-btn>
												
												<v-btn v-if="selectedEvent.file_reagentes_equipamentos" 
													@click.stop="downloadFile(get_base_url_backend+selectedEvent.file_reagentes_equipamentos)"
													color="blue" class="mr-1 mt-1 white--text" 
													:small="$vuetify.breakpoint.xsOnly">
													Lista de Materiais <v-icon right dark> mdi-cloud-download </v-icon>
												</v-btn>
											</div>
										</div>
										<v-divider class="py-2"></v-divider>
									</v-card-text>
									<v-card-actions>
										<v-btn small text :color="$vuetify.theme.themes.dark.primary" @click="()=>{selectedOpen = false}">
											Fechar
										</v-btn>
										<v-spacer></v-spacer>
										
									</v-card-actions>
								</v-card>
							</v-menu>
						</v-sheet>
					</v-col>
				</v-row>
			
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import FrontendConfigService from '@/services/configs/frontendConfigService'
import BackendConfigService from '@/services/configs/backendConfigService'
export default {
	name:'AgendamentosTodos',
	data: () => ({
		dialog: false,
		focus: '',
		type:'category',
		interval:null,
		filterDatePicker: '',
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
	}),
	mounted() {
		//this.$refs.calendar.checkChange()
		this.loadAgendamentos()
		
	},
	methods: {
		onLoad(){
			this.interval = setInterval(
				()=> this.loadAgendamentos(), 60000
			)
		},
		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event;
				this.selectedElement = nativeEvent.target;
				setTimeout(() => {
				this.selectedOpen = true;
				}, 10);
			};

			if (this.selectedOpen) {
				this.selectedOpen = false;
				setTimeout(open, 10);
			} else {
				open();
			}
			
			nativeEvent.stopPropagation();
		},
		xshowEvent(event){
			let evento = event.event
			let resumo = ''
			resumo += '\nSolicitante: ' + evento.solicitante
			resumo += '\nLaboratório: ' + evento.category
			resumo += '\nData/Hora: ' + evento.data
			resumo += '\nStatus: ' + evento.status_agenda
			resumo += '\nTítulo prática: ' + evento.titulo_aula
			alert(resumo)
		},
		getEventColor (event) {
			return event.color
		},
		onChange(value){
			//console.log('onChange',value)
			this.$store.agendamentosTodosStore.dispatch('get_agendas',`?status_agenda=Aprovado&status_agenda=Pendente&mes=${value.start.month}`)
		},
		setToday () {
			this.focus = ''
		},
		prev () {
			this.$refs.calendar.prev()
		},
		next () {
			this.$refs.calendar.next()
		},
		viewDay({date}) {
			this.focus = date;
			this.type = "day";
		},
		loadAgendamentos(){
			//let mes = new Date()
			//mes = mes.getMonth()+1
			//carrega as salas para utilizar como categorias
			this.$store.agendamentosTodosStore.dispatch('get_salas')
			//carrega a agenda apenas de aprovados e Pendentes
			//this.$store.agendamentosTodosStore.dispatch('get_agendas',`?status_agenda=Aprovado&status_agenda=Pendente&mes=${mes}`)
		},
		downloadFile(url){
			window.open(url)
		}
	},
	computed:{
		computedIsLoading(){
			return this.$store.agendamentosTodosStore.getters.getIsLoading
		},
		computedNotifications(){
            return this.$store.agendamentosTodosStore.getters.getNotifications
        },
        get_base_url_backend(){
			const backend = new BackendConfigService()
			const url = backend.get_base_url_backend()
			return url
		},
	},
	watch:{
		computedNotifications:{
            handler(errors){
                for(let message of errors){
                    let options = FrontendConfigService.getOptionsToast()
                    this.$toast(message.message, {
                        type: message.tag,
                        ...options
                    })
                }
            }, deep:true
        },
		dialog(value){
			if(value){
				//console.log('abrindo todos')
				this.onLoad()
			}
			if(!value && this.interval){
				clearInterval(this.interval)
			}
		},
		filterDatePicker(val){
			this.focus = val
			this.type = 'category'
		},
	}
}
</script>